import React from "react";
import {useFormContext} from "react-hook-form";
import {FilterComponent} from "./FilterComponent";
import {useTranslation} from "react-i18next";

function DocumentType(): React.ReactElement {
    const form = useFormContext();
    const {t} = useTranslation();

    const DocumentTypes = {
        0: t('user-page.invoice.filters.invoice-types.invoice-sale'),
        1: t('user-page.invoice.filters.invoice-types.correction-quantity'),
        2: t('user-page.invoice.filters.invoice-types.correction-value'),
        3: t("user-page.invoice.filters.invoice-types.all"),
    };
    
    const orderedKeys: (keyof typeof DocumentTypes)[] = [3, 0,1,2];


    return (
        <FilterComponent title={t('user-page.invoice.filters.document-type')} >
            <select {...form.register('document-type')} >
            {orderedKeys.map((key) => (
                    <option key={key} value={key}>
                        {DocumentTypes[key]}
                    </option>
                ))}
            </select>
        </FilterComponent>
    );
}

export {DocumentType};